import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Billboard from "@/pages/Billboard";

function App() {
  return (
    <div className="App min-h-screen bg-black text-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Billboard />} />
          <Route path="*" element={<Billboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
